"use strict";

export function initProductCardImagesSwiper() {
    const swipers = new Swiper(".product-card__images-carousel-wrapper", {
        loop: true,
        loopAdditionalSlides: 3,
        spaceBetween: 2,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        nested: true,
        lazy: {
            // checkInView: false,
            // scrollingElement: 'window',
            // loadPrevNext: false,
            // loadPrevNextAmount: 1,
            // loadOnTransitionStart: false,
            // elementClass: 'swiper-lazy',
            // loadingClass: 'swiper-lazy-loading',
            // loadedClass: 'swiper-lazy-loaded',
            // preloaderClass: 'swiper-lazy-preloader',
        },
        preloadImages: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: 'bullets',
            bulletElement: 'custom',
            bulletActiveClass: 'active',
            bulletClass: 'product-card__images-navigation',
            renderBullet: function (index, className) {
                return `<button class="product-card__images-navigation" aria-label="Product photo - ${++index}"></button> `;
            },
        },
        autoplay: {
            delay: 1500,
        },
        on: {
            slideChange: function(swiper) {
                if (swiper && swiper.autoplay?.running) {
                    const totalSlidesCount = swiper.wrapperEl.childElementCount;
                    const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                    swiper.lazy.loadInSlide(nextSlideIndex);
                }
            },
            touchStart: function(swiper, event) {
                const totalSlidesCount = swiper.wrapperEl.childElementCount;
                const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                const prevSlideIndex = swiper.activeIndex - 1 <= 0 ? totalSlidesCount : swiper.activeIndex - 1;
                swiper.lazy.loadInSlide(prevSlideIndex);
                swiper.lazy.loadInSlide(nextSlideIndex);
                for (let i = 0; i < totalSlidesCount; i++) {
                    if (![prevSlideIndex, swiper.activeIndex, nextSlideIndex].includes(i)) {
                        swiper.lazy.loadInSlide(i);
                    }
                }
            }
        }
    });

    (Array.isArray(swipers) ? swipers : [swipers]).forEach((swiper) => {
        if (!swiper) {
            return;
        }
        swiper.autoplay.stop();
        if (swiper.pagination.bullets?.length <= 1) {
            swiper.pagination.destroy();
            jQuery(swiper.el).find('.product-card__images-navigation').remove();
            swiper.destroy();
        }
    });
}

export function initProductCardCarouselSwiper() {
    const carousels = $(".product-card__container--carousel > .swiper-container");

    carousels.each((index, carousel) => {
        const cardsLength = $(carousel).find('.product-card').length;
        const getEnable = () => {
            let enabled;
            if (window.innerWidth < 576) {
                enabled = cardsLength > 2;
            } else if (window.innerWidth < 768) {
                enabled = cardsLength > 2;
            } else if (window.innerWidth < 992) {
                enabled = cardsLength > 3;
            } else if (window.innerWidth < 1200) {
                enabled = cardsLength > 4;
            } else {
                enabled = cardsLength > 5;
            }
            return enabled;
        }

        /**
         * deprecated
         * @returns {number}
         */
        const getSlidesPerGroup = () => {
            let slidesPerGroup;
            if (window.innerWidth < 576) {
                slidesPerGroup = getEnable() ? 1 : 2;
            } else if (window.innerWidth < 768) {
                slidesPerGroup = getEnable() ? 1 : 2;
            } else if (window.innerWidth < 992) {
                slidesPerGroup = getEnable() ? 1 : 3;
            } else if (window.innerWidth < 1200) {
                slidesPerGroup = getEnable() ? 1 : 4;
            } else {
                slidesPerGroup = getEnable() ? 1 : 5;
            }
            return slidesPerGroup;
        }

        const swiper = new Swiper(carousel, {
            loop: getEnable(),
            loopAdditionalSlides: 1,
            loopFillGroupWithBlank: false,
            centerInsufficientSlides: true,
            resizeObserver: true,
            updateOnWindowResize: true,
            watchOverflow: true,
            freeModeSticky: true,
            slidesPerView: 2,
            spaceBetween: 0,
            enabled: getEnable(),
            navigation: {
                prevEl: ".skl-icon-angle-left",
                nextEl: ".skl-icon-angle-right",
            },
            slideClass: 'product-card',
            on: {
                resize: () => {
                    const enabled = getEnable();
                    if (enabled) {
                        swiper.enable();
                    } else {
                        swiper.disable();
                    }
                    if (swiper.params.loop !== enabled){
                        swiper.params.loop = enabled;
                        if (enabled) {
                            swiper.loopCreate();
                        } else {
                            swiper.loopDestroy();
                        }
                    }
                },
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 14,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 12,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 12,
                },
                // 1600: {
                //     slidesPerView: 5,
                //     spaceBetween: 12,
                // },
                // 1920: {
                //     slidesPerView: 5,
                //     spaceBetween: 12,
                // },
            },
        });
    });
}

export function initProductCardCarouselHover() {
    jQuery('.product-card__images-carousel-wrapper .product-card__images').hover(
        productCardCarouselHoverIn,
        productCardCarouselHoverOut
    );
}

export function productCardCarouselHoverIn() {
    const carousel = jQuery(this).closest('.product-card__images-carousel-wrapper').get(0);
    if (carousel?.swiper?.pagination?.bullets?.length > 1) {
        carousel?.swiper?.autoplay?.start();
        const totalSlidesCount = jQuery(this).childElementCount;
        const nextSlideIndex = carousel?.swiper.activeIndex + 1 >= totalSlidesCount ? 0 : carousel?.swiper.activeIndex + 1;
        carousel?.swiper?.lazy.loadInSlide(nextSlideIndex);
    }
}

export function productCardCarouselHoverOut() {
    const carousel = jQuery(this).closest('.product-card__images-carousel-wrapper').get(0);
    carousel?.swiper?.autoplay.stop();
}

export default function init() {
    if (!$('.product-card').length) {
        return;
    }
    initProductCardCarouselSwiper();
    initProductCardImagesSwiper();
    initProductCardCarouselHover();
}
